var map = {
	"./01-1.png": "ee6f",
	"./01.png": "5067",
	"./ID1.png": "0597",
	"./ability/1_1.png": "0e60",
	"./ability/2_1.png": "f2a0",
	"./ability/2_11.png": "b5a9",
	"./ability/3_1.png": "92e6",
	"./ability/4_1.png": "674a",
	"./ability/5_1.png": "aebe",
	"./ability/5_11.png": "f176",
	"./android1.png": "8c22",
	"./applet1.png": "8d9b",
	"./block/1.png": "bc9f",
	"./card/1.png": "baf1",
	"./chaungjian1.png": "ac05",
	"./game/swiper1_1.png": "8c7f",
	"./guide/1.png": "ce9e",
	"./index/1-1.png": "db5c",
	"./index/1.png": "fe48",
	"./index/2-1.png": "d0aa",
	"./index/3-1.png": "4307",
	"./index/4-1.png": "189c",
	"./index/b2c-mall/banner1.png": "49b2",
	"./index/b2c-mall/img1.png": "9bd2",
	"./index/banner/banner1.png": "bcab",
	"./index/bg1.png": "296e",
	"./index/block-chain/img1.png": "9028",
	"./index/card/img1.png": "f121",
	"./index/game/card1.png": "a788",
	"./index/guide/func1.png": "a9ac",
	"./index/guide/img1.png": "c309",
	"./index/icons/1.png": "5406",
	"./index/icons/11.png": "33dd",
	"./index/icons/icon1.png": "840f",
	"./index/industry/btn-1.png": "3e47",
	"./index/life/img1.png": "f2c4",
	"./index/live-video/library1.png": "1a3e",
	"./index/mall/banner1.png": "d2a0",
	"./index/mall/img1.png": "faaa",
	"./index/mall/show1.png": "2a56",
	"./index/member-mall/show1.png": "b0f8",
	"./index/o2o-mall/banner1.png": "3efe",
	"./index/o2o-mall/img1.png": "dfd0",
	"./index/order/img1.png": "4e23",
	"./index/scm/img1.png": "8d9c",
	"./index/scm/img11.png": "0bc3",
	"./index/scm/show1.png": "c42b",
	"./index/shangcheng-1.png": "7f2e",
	"./index/short-play/img1.png": "86a1",
	"./index/takeaway/img1.png": "8a3b",
	"./index/team-selection/show1.png": "8e8d",
	"./index/travel/img1.png": "76c2",
	"./institution/1.png": "cf0d",
	"./ios1.png": "91f9",
	"./live-video/bg1.png": "1e60",
	"./live-video/icon1.png": "5c43",
	"./live-video/swiper1_1.png": "6dbf",
	"./live-video/swiper2_1.png": "c940",
	"./local/1.png": "c708",
	"./mall/1.png": "0a1e",
	"./mall/fg1.png": "a77c",
	"./mall/step_1_1.png": "44c2",
	"./mall/step_2_1.png": "9a04",
	"./mall/step_3_1.png": "f159",
	"./mokuai1.png": "b539",
	"./money1.png": "7c74",
	"./more-mall/1.png": "0e09",
	"./o2o/1.png": "c8d3",
	"./o2o/bg1.png": "0d75",
	"./o2o/fg1_1.png": "e5f4",
	"./o2o/fg2_1.png": "d1bdd",
	"./o2o/fg3_1.png": "5fd2",
	"./o2o/fg4_1.png": "44a9",
	"./o2o/step_1_1.png": "587e",
	"./o2o/step_2_1.png": "429d",
	"./o2o/step_3_1.png": "ff5f",
	"./o2o/step_4_1.png": "f172",
	"./provider/1.png": "3eec",
	"./provider/bg1.png": "8acf",
	"./provider/fg1.png": "488e",
	"./provider/step_1_1.png": "3452",
	"./provider/step_2_1.png": "ee5d",
	"./provider/step_3_1.png": "4059",
	"./provider/step_4_1.png": "ff41",
	"./recommend/1.png": "028b",
	"./web1.png": "52f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d550";